import { useCallback } from 'react';
import {
  createSearchParams,
  type Location,
  NavigateOptions,
  useLocation,
  useNavigate,
} from 'react-router';

import { RouteEnum } from '@/layouts/routes/model/Route.model.ts';
import { LocalStorageParam, setLocalStorage } from '@/utils/localStorage.util';

export type PathParams = { params: Record<string, string>; pathname: Path } | Path;
type Path = RouteEnum | string;

interface Return {
  location: Location;
  push: (path: PathParams, state?: NavigateOptions) => void;
}

export const useAppHistory = (): Return => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    location,
    push: useCallback(
      (path, state) => {
        setLocalStorage(LocalStorageParam.LAST_VISITED_LOCATION, path);

        if (typeof path === 'object') {
          void navigate(
            {
              pathname: path.pathname,
              search: `?${createSearchParams(path.params)}`,
            },
            { state },
          );
          return;
        }
        void navigate(path, { state });
      },
      [navigate],
    ),
  };
};
